import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { RiMenuUnfold4Line, RiMenuUnfoldLine } from "react-icons/ri";
import { sideBarChange } from "../Reducer/componentSlice";
import { sidebarMenu } from "./sidebarMenu";
import { storageRemoveItem } from "../Helpers/Utils";
import Logo from "../Assets/images/logo.svg";

const Sidebar = () => {
    const dispatch = useDispatch();
    const component = useSelector((state) => state.component);
    const location = useLocation();

    const clearFilter = () => storageRemoveItem("filter");
    const changeBar = () => dispatch(sideBarChange(!component?.sideBar));
    const closeMobileNav = () => dispatch(sideBarChange(true));

    const renderMenu = (collapsed) =>
        sidebarMenu?.map((group, i) => (
            <React.Fragment key={i}>
                {!collapsed ? <label className="side-bar-label">{group?.title}</label> : ""}
                <ul className="ms-2">
                    {group?.items?.map((item) => (
                        <li key={item?.path}>
                            <Link
                                to={item?.path}
                                onClick={clearFilter}
                                title={collapsed ? item?.name : undefined}
                                className={`${location.pathname?.split("/")?.includes(item.check) ? "active-side-bar-path" : ""} my-2 side-bar-path ${collapsed ? "d-flex justify-content-center align-items-center fs-5" : ""}`}
                            >
                                {item?.icon}
                                {!collapsed ? item?.name : ""}
                            </Link>
                        </li>
                    ))}
                </ul>
            </React.Fragment>
        ));

    return (
        <React.Fragment>
            {component?.offCanva ? (
                <>
                    {!component?.sideBar && <div className="sidebar-backdrop" onClick={closeMobileNav}></div>}
                    <div
                        className={`offcanvas offcanvas-end ${!component?.sideBar ? "show" : ""}`}
                        tabIndex="-1"
                        style={{ visibility: !component?.sideBar ? "visible" : "hidden" }}
                    >
                        <div className="offcanvas-header">
                            <img src={Logo} alt="logo" className="offcanvas-brand" />
                            <button type="button" className="btn-close text-reset" aria-label="Close menu" onClick={closeMobileNav}></button>
                        </div>
                        <div className="offcanvas-body p-0">
                            <div className="my-3 mx-4">{renderMenu(false)}</div>
                        </div>
                    </div>
                </>
            ) : (
                <div className={`sidebar ${component?.sideBar ? "sidebar-lg" : "sidebar-sm"}`}>
                    <div className="text-end">
                        <button
                            className="btn side-bar-open"
                            onClick={changeBar}
                            aria-label={component?.sideBar ? "Collapse menu" : "Expand menu"}
                        >
                            {component?.sideBar ? <RiMenuUnfold4Line /> : <RiMenuUnfoldLine />}
                        </button>
                    </div>
                    <div className="overflow-y-scroll w-100">{renderMenu(!component?.sideBar)}</div>
                </div>
            )}
        </React.Fragment>
    );
};

export default Sidebar;
